<template>
  <div @click="repeatClick" class="pages">

    <div class="load1">

      <!-- 移动设备 -->
      <div v-if="!isPC"  class="load2">
        <p class="load_img">
          <img src="https://file.zuopin.cloud/wechat_logo.svg" alt class="load_img_1"/>
        </p>
        <div class="load_text">
          <div class="load_text_1">正在跳转微信</div>
          <div class="load_text_2">若未跳转，请轻点屏幕重试</div>
        </div>
      </div>

      <!-- PC -->
      <div v-else class="load2">
        <p class="load_img">
          <!-- <img src="https://file.zuopin.cloud/FtYADZF5B1Jn7J4C-fSeF64M-7_7" alt class="load_img_1"/> -->
          <img :src="xacode" alt class="load_img_1"/>
        </p>
        <div class="load_text">
          <div class="load_text_1">请用装有微信的移动设备打开链接</div>
          <div class="load_text_2">亦可用微信扫码访问</div>
        </div>
      </div>

    </div>

    <!-- <div @click="repeatClick" class="repat-btn">再试一次</div> -->
    <!-- <div class="saveToXcxs" v-if="loading">
      <p class="xcxP2">
        <img src="../../assets/img/loads.svg" alt class="loads" />
        同步中
      </p>
    </div> -->

    <transition name="el-zoom-in-top">
    <!-- <div> -->
      <div class="generalTip" :class="tipType ? 'black' : ''" v-show="tipShow">
        <p>{{ tipMessage }}</p>
      </div>
    <!-- </div> -->
    </transition>

  </div>
</template>

<script>
// import headers from "../../components/header";
//import lrz from "lrz";
import { Message } from "element-ui";
import { getUrlLinkByCode  } from "@/request/api";
import storage from '../../utils/storage';

import Axios from "axios";

let that

export default {
//   components: { headers },
  name: "urllink",
  data() {
    return {
      code: "",
      linkUrl:"",
      loading: true,
      loadText: '授权中',
      errorMask: false,
      tipShow: false,
      tipType: false,
      tipMessage: "通用错误",
      isPC:false,
      xacode:'',
    };
  },
  mounted() {
    that = this
    console.log('route', this.$route);

    that.code = this.$route.query.code;

    if(!that.code)
    {
      Message.error("非法请求！");
      return
    }

    // {
    //   that.tipShow = true;
    //   that.tipType = false;
    //   that.tipMessage = "非法请求";
    //   setTimeout(() => {
    //     that.tipShow = false;
    //   }, 1000);
    //   that.loading = false;
    //   that.loadText = '非法请求';
    // }

    that.isPC = that.checkIsPC()
    
    that.initData()
  },
  methods: {
    repeatClick()
    {
      if(that.linkUrl){
        window.location.href = that.linkUrl;
        return;
      }

      that.initData()
    },
    initData()
    {
      var key = that.getKey();
      var localData = storage.get(key)
      
      if(localData && localData.item)
      {
        try{
          var url = decodeURIComponent(localData.item)
          // if(url)
          // {
          //   console.log('localData',url)
          //   if(!that.isPC){
          //     //Message.success('授权成功')
          //     that.linkUrl = url;
          //     window.location.href = that.linkUrl;
          //   }
          //   else
          //   {
          //     that.xacode = url;
          //   }
          //   return;
          // }
        }
        catch{

        }
        
      }
      that.getUrlLink()
    },
    // 获取项目列表
    getUrlLink() {
      var params = {
        code:that.code,
        ispc: (that.isPC? 1 : 0),
      }
      
      console.log('getUrlLinkByCode-data',params)

      getUrlLinkByCode(params).then((res) => {

        //alert(JSON.stringify(res))
        console.log('getUrlLinkByCode',res)
        
        if (res.data && res.data.data)
        {
          that.loading = true;
          that.loadText = '授权成功';
          if(!that.isPC)
          {
            if(res.data.data.data && res.data.data.data.url_link)
            {
              var url_link = res.data.data.data.url_link;
              var key = that.getKey();

              storage.set(key,encodeURIComponent(url_link))

              that.linkUrl = url_link;
              //Message.success('授权成功')
              window.location.href = that.linkUrl;
            }
          }
          else
          {
            that.xacode = res.data.data.xacode;
          }
        } 
        else 
        {
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = "授权失败";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);
          that.loading = false;
          that.loadText = '授权失败';
          // that.transparentMask = false;
        }
      });
    },
    getKey()
    {
      var key = 'link_' +  this.code 
      return key;
    },
    checkIsPC() 
    {
      console.log('checkIsPC')
	    var userAgentInfo = navigator.userAgent;
	    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod", "iPad"];
	    var flag = true;
	    for (var i = 0; i < Agents.length; i++) {
	        if (userAgentInfo.indexOf(Agents[i]) > 0) {
	            flag = false;
	            break;
	        }
	    }
	    return flag;
    }
  }
};
</script>

<style lang="less" scoped>


.pages{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-right: 2rem;
  padding-bottom: calc(10px + constant(safe-area-inset-bottom)) !important;
  padding-bottom: calc(10px + env(safe-area-inset-bottom)) !important;
}

.load1{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}

.load2{
  height: 7rem;
  width: 100%;
  // margin-top: -20%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: space-between;
}

.load_img{
  width: 100%;
}

.load_img_1{
  width: 4.5rem;
  height: 4.5rem;
}

.load_text{
  width: 100%;
  line-height: 0.9rem;
  text-align: center;
}

.load_text_1{
  color: rgba(0,0,0);
  font-size: 0.55rem;
  font-weight: 800;
}

.load_text_2{
  color: rgba(0,0,0,0.4);
  font-size: 0.4rem;
  font-weight: 400;
}

.repat-btn{
  width: 8rem;
  height: 1.2rem;
  line-height: 1.2rem;
  border-radius: 1.2rem;
  text-align: center;
  background: #000;
  color: #fff;
  font-size: 0.5rem;
  z-index: 100;
  bottom: calc(10px + constant(safe-area-inset-bottom)) !important;
  bottom: calc(10px + env(safe-area-inset-bottom)) !important;
}

.generalTip {
  position: fixed;
  top: 0.5rem;
  background: #ec4d3d;
  color: #ffffff;
  text-align: center;
  width: 4.7rem;
  height: 1.4rem;
  line-height: 1.4rem;
  border-radius: 1.4rem;
  font-size: 0.4rem;
  z-index: 1009;
  // transform: translate3d(0,-110px, 0);
  // transition: transform .2s linear;
}

// .slideinto {
//   transform: translate3d(0, 110px, 0);
//   transition: transform 0.2s linear;
// }

// .slideout {
//   transform: translate3d(0, 0, 0);
//   transition: transform 0.2s linear;
// }

// .generalTip .show{
//   transform: translate3d(0, 0, 0);
// }

// .generalTip .move{
//   transition: all 0 ease 0;
// }

.black {
  background: #000;
}

 .saveToXcxs {
      width: 150px;
      height: 40px;
      background: #000;
      border-radius: 40px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column-reverse;
      z-index: 999;
      margin-left: 20px;
      cursor: pointer;
      .xcxP2 {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

</style>
